import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

export default function DashboardCard({
  title,
  extra,
  children,
  style,
  bodyStyle,
}) {
  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 14,
        boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.03)',
        ...style,
      }}
      styles={{
        body: {
          padding: 18,
          ...bodyStyle,
        },
      }}
      title={
        title ? (
          <Text strong style={{ fontSize: 14 }}>
            {title}
          </Text>
        ) : undefined
      }
      extra={extra}
    >
      {children}
    </Card>
  );
}
